'use client';
import { createSafeContext } from '@s7/react-utils';
import { DesignSystemError } from '@s7/system';
import { POPOVER_ERRORS_CONTEXT } from './Popover.errors.js';

var _createSafeContext = createSafeContext(new DesignSystemError("ui", POPOVER_ERRORS_CONTEXT));
var PopoverContextProvider = _createSafeContext[0], usePopoverContext = _createSafeContext[1];

export { PopoverContextProvider, usePopoverContext };
